window.onloadRecaptchaCallback = ->
  $(".g-recaptcha-v3").each ->
    if ($(this).find("iframe").length)
      return

    grecaptcha.ready( ->
      sitekey = $(".g-recaptcha-v3").attr("data-sitekey-v3")
      action = $(".g-recaptcha-v3").attr("data-action")
      grecaptcha.execute(sitekey, { action: action }).then((token) ->
        $(".g-recaptcha-v3").append('<input type="hidden" name="g-recaptcha-response" value="' + token + '">')
      )
    )
  return
